<script setup lang="ts">
import { DropdownMenuTrigger } from 'reka-ui';

withDefaults(
    defineProps<{
        asChild?: boolean;
    }>(),
    {
        asChild: true,
    },
);
</script>

<template>
    <DropdownMenuTrigger :as-child="asChild">
        <slot>
            <div
                class="inline-flex cursor-pointer rounded-md py-1 transition hover:bg-muval-gray-5"
                :class="$attrs.class"
            >
                <SvgIcon
                    name="system-kebab-menu"
                    class="h-6 w-6 text-muval-gray-1"
                />
            </div>
        </slot>
    </DropdownMenuTrigger>
</template>
